import React from 'react';
import { Navigate } from 'react-router-dom';

const OnboardingCompleted = () => (
  <Navigate to="/client/dashboard" replace />
);

export default OnboardingCompleted;
